// 專題 焦點關鍵字
import Tag from "../layout/Tag";

const ProjectKeyword = ({ tags }) => {
  return (
    <div className="w-full max-w-[680px] mx-auto center-center mt-[35px] gap-x-[6px] gap-y-[12px] [&>*]:tag flex-wrap">
      {tags?.map((tag, i) => (
        <Tag tag={tag} key={"project-tag" + tag + i} location="project">
          {tag}
        </Tag>
      ))}
    </div>
  );
};

export default ProjectKeyword;
